import React from 'react';

import { Checkbox } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';

import CustomTableRow from 'components/shared/CustomTable/CustomTableRow';
import CustomBodyTableCell from 'components/shared/CustomTable/CustomBodyTableCell';

import { palette } from 'themeV5/palette';
import type { AlertValues } from 'views/Alerts/models/alert';

interface Props {
  row: AlertValues;
  index: number;
  handleClick: (
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>,
    index: number,
  ) => void;
}

const AlertsTableRow = ({ row, index, handleClick }: Props) => {
  const isItemSelected = row.isSelected;
  const labelId = `enhanced-table-checkbox-${index}`;

  return (
    <CustomTableRow
      key={row as any}
      hover
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      selected={isItemSelected}
      onClick={(event) => handleClick(event, index)}
    >
      <CustomBodyTableCell padding="checkbox">
        <Checkbox
          checked={row.isSelected}
          inputProps={{ 'aria-labelledby': labelId }}
        />
      </CustomBodyTableCell>
      <CustomBodyTableCell>{row?.description}</CustomBodyTableCell>
      <CustomBodyTableCell>{row?.eventType}</CustomBodyTableCell>
      <CustomBodyTableCell>
        {!row.viewed ? (
          <NotificationsIcon style={{ color: palette.orange[200] }} />
        ) : (
          false
        )}
      </CustomBodyTableCell>
    </CustomTableRow>
  );
};

export default AlertsTableRow;
